import ButtonCards from '@/components/buttonCardGroup';
import { useHistoryNavigator } from '@/navigation';
import ICONS from '@/shared/entities/constants/icons';
import React from 'react';
import { Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

export const SelectHealthConfig: React.FC = () => {
  const navigator = useHistoryNavigator();

  return (
    <Grid column gap={24} stretch growing>
      <Text value='Selecione qual permissão deseja configurar:' size='larger' />
      <ButtonCards
        data={[
          {
            iconImageUrl: ICONS.PLAN,
            iconColor: 'light',
            onClick: () => navigator.push('/health-manage/health-data'),
            title: 'Indicadores Plano de Saúde',
          },
          {
            iconImageUrl: ICONS.VITTA,
            onClick: () => navigator.push('/health-manage/digital-hospital'),
            title: 'Indicadores Hospital Digital',
          },
        ]}
      />
    </Grid>
  );
};
